export type VehicleLookupErrorKind =
  | "invalid_plate"
  | "not_found"
  | "fipe_not_found"
  | "temporarily_unavailable"

export type VehicleLookupUserError = {
  kind: VehicleLookupErrorKind
  title: string
  message: string
}

const INVALID_PLATE_MESSAGE = "Confira se a placa foi digitada corretamente. Use ABC-1234 ou ABC1D23."

const normalizeMessage = (message?: string | null) =>
  (message ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()

export const PLACA_INVALIDA_ERROR: VehicleLookupUserError = {
  kind: "invalid_plate",
  title: "Placa inválida",
  message: INVALID_PLATE_MESSAGE,
}

export const DADOS_VEICULO_NAO_ENCONTRADOS_ERROR: VehicleLookupUserError = {
  kind: "not_found",
  title: "Não encontramos os dados desse veículo",
  message: "Confira a placa e tente novamente. Se preferir, preencha manualmente.",
}

export const FIPE_NAO_ENCONTRADA_ERROR: VehicleLookupUserError = {
  kind: "fipe_not_found",
  title: "Valor FIPE não encontrado",
  message: "Você pode informar o valor manualmente no fechamento.",
}

export const CONSULTA_INDISPONIVEL_ERROR: VehicleLookupUserError = {
  kind: "temporarily_unavailable",
  title: "Não foi possível consultar os dados agora",
  message: "Tente novamente em alguns minutos ou preencha manualmente.",
}

export const isInvalidPlateLookupError = (message?: string | null) => {
  const normalized = normalizeMessage(message)
  return (
    normalized.includes("placa invalida") ||
    normalized.includes("formato") ||
    normalized.includes("confira se a placa foi digitada corretamente")
  )
}

const isNotFoundLookupError = (message?: string | null) => {
  const normalized = normalizeMessage(message)
  return (
    normalized.includes("nao encontrado") ||
    normalized.includes("nao encontrados") ||
    normalized.includes("not found") ||
    normalized.includes("status_code: 404") ||
    normalized.includes("404") ||
    normalized.includes("cadastre o veiculo manualmente")
  )
}

const isFipeNotFoundLookupError = (message?: string | null) => {
  const normalized = normalizeMessage(message)
  return isNotFoundLookupError(message) || normalized.includes("informar o valor manualmente")
}

const isTechnicalOrProviderError = (message?: string | null) => {
  const normalized = normalizeMessage(message)
  return (
    normalized.includes("fornecedor") ||
    normalized.includes("provider") ||
    normalized.includes("status_code") ||
    normalized.includes("status code") ||
    normalized.includes("http") ||
    normalized.includes("api") ||
    normalized.includes("apibrasil") ||
    normalized.includes("token") ||
    normalized.includes("authorization") ||
    normalized.includes("unauthorized") ||
    normalized.includes("cobrad") ||
    normalized.includes("tarifad") ||
    normalized.includes("requisic") ||
    normalized.includes("tente novamente em alguns minutos")
  )
}

export const getPlateLookupUserError = (message?: string | null): VehicleLookupUserError => {
  if (!message) return CONSULTA_INDISPONIVEL_ERROR
  if (isInvalidPlateLookupError(message)) return PLACA_INVALIDA_ERROR
  if (isNotFoundLookupError(message)) return DADOS_VEICULO_NAO_ENCONTRADOS_ERROR
  if (isTechnicalOrProviderError(message)) return CONSULTA_INDISPONIVEL_ERROR

  return DADOS_VEICULO_NAO_ENCONTRADOS_ERROR
}

export const getFipeLookupUserError = (message?: string | null): VehicleLookupUserError => {
  if (!message) return CONSULTA_INDISPONIVEL_ERROR
  if (isInvalidPlateLookupError(message)) return PLACA_INVALIDA_ERROR
  if (isFipeNotFoundLookupError(message)) return FIPE_NAO_ENCONTRADA_ERROR
  if (isTechnicalOrProviderError(message)) return CONSULTA_INDISPONIVEL_ERROR

  return FIPE_NAO_ENCONTRADA_ERROR
}
